/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext } from 'react';
import { Map, TileLayer } from 'react-leaflet';
import RotatedMarker from './RotatedMarker';
import L from 'leaflet';
import styles from './styles.module.css';
import { Col, Row, Typography } from 'antd';
import { EnvironmentOutlined, RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { DeviceDetailsContext } from '../../../../index';
import { withConfigContext } from '../../../../../../../../components/ConfigContext';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment-timezone';

TimeAgo.addLocale(en);

const { Title } = Typography;

const iconActive = new L.Icon({
  iconUrl: require('./pin-active.svg'),
  iconRetinaUrl: require('./pin-active.svg'),
  shadowUrl: require('./pin-shadow.svg'),
  shadowSize: new L.Point(51, 51),
  shadowAnchor: [22, 22],
  popupAnchor: [0, -22],
  iconSize: new L.Point(50, 50),
});

const iconInactive = new L.Icon({
  iconUrl: require('./pin-inactive.svg'),
  iconRetinaUrl: require('./pin-inactive.svg'),
  shadowUrl: require('./pin-shadow.svg'),
  shadowSize: new L.Point(51, 51),
  shadowAnchor: [22, 22],
  popupAnchor: [0, -22],
  iconSize: new L.Point(50, 50),
});

const DeviceLocation = props => {
  const config = props.context;
  const deviceDetails = useContext(DeviceDetailsContext);
  const attribution =
    '&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors';
  const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  const { location } = props;
  let position = [0, 0];
  let rotationAngle = 0;
  let icon = iconInactive;
  if (location != null) {
    position = [location.latitude, location.longitude];
    rotationAngle = location.bearing;
    if (deviceDetails.device.enrolmentInfo.status === 'ACTIVE') {
      icon = iconActive;
    }
  }
  const { t } = useTranslation();
  return (
    <div>
      <Row>
        <Col sm={16}>
          <Title level={4} className={styles.title}>
            <EnvironmentOutlined /> {t('title_deviceLocation')}
            <span className={styles.updatedTime}>
              {moment
                .utc(location.updatedTime)
                .tz(moment.tz.guess())
                .format('LLLL')}
              {` (${moment
                .utc(location.updatedTime)
                .tz(moment.tz.guess())
                .fromNow()})`}
            </span>
          </Title>
        </Col>
        <Col sm={8} className={styles.locationHistory}>
          <Link
            to={`/${config.appName}/geo/history/${props.deviceType}/${props.deviceIdentifier}`}
          >
            {t('title_locationHistory')} <RightOutlined />
          </Link>
        </Col>
      </Row>
      <Map center={position} zoom={16} className={styles.map}>
        <TileLayer attribution={attribution} url={url} />
        <RotatedMarker
          icon={icon}
          position={position}
          rotationAngle={rotationAngle}
          rotationOrigin={'center'}
        />
      </Map>
    </div>
  );
};

export default withConfigContext(DeviceLocation);
